// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/Tour/CountryHandlers.jsx

import React, { useState, useEffect, useCallback } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { ConfirmDialog } from 'primereact/confirmdialog';
import CountryList from './CountryList';
import { API_ENDPOINTS } from '../../api/api';

// CSS imports for PrimeReact components
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

const CountryHandlers = ({ country_ID, setFormData }) => {
  const [allCountries, setAllCountries] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [manageDialogVisible, setManageDialogVisible] = useState(false);

  const fetchCountries = useCallback(async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const authHeader = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` };
      const response = await fetch(API_ENDPOINTS.COUNTRY_VIEW, { headers: authHeader });
      if (!response.ok) throw new Error(`Failed to fetch countries: ${response.status}`);
      const data = await response.json();
      setAllCountries(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error fetching countries:", error);
      setAllCountries([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCountries();
  }, [fetchCountries]);

  useEffect(() => {
    if (allCountries.length > 0 && Array.isArray(country_ID)) {
      const currentlySelected = allCountries.filter(country =>
        country_ID.some(selected => String(selected.id) === String(country.country_ID))
      );
      setSelectedCountries(currentlySelected);
    } else {
      setSelectedCountries([]);
    }
  }, [country_ID, allCountries]);

  const handleSelectionChange = (e) => {
    const selected = e.value || [];
    setSelectedCountries(selected);
    const newCountryIds = selected.map(country => ({ id: String(country.country_ID) }));
    setFormData(prev => ({ ...prev, country_ID: newCountryIds }));
  };

  const countryTemplate = (option) => (
    <div className="flex align-items-center">
      <div>{option.country_NameEN} ({option.country_NameTH})</div>
    </div>
  );

  return (
    <div className="mb-3">
      <ConfirmDialog /> 
      
      <label htmlFor="country-multiselect" className="form-label">Countries</label>
      <div className="p-inputgroup">
        <MultiSelect
          id="country-multiselect"
          value={selectedCountries}
          options={allCountries}
          onChange={handleSelectionChange}
          optionLabel="country_NameEN"
          itemTemplate={countryTemplate}
          placeholder={loading ? "Loading..." : "Select Countries"}
          display="chip"
          className="w-full"
          filter
          filterBy="country_NameEN,country_NameTH"
          dataKey="country_ID"
          disabled={loading || allCountries.length === 0}
        />
        <Button 
          type="button" // [FIXED] Explicitly set type to "button" to prevent form submission
          icon="pi pi-cog" 
          className="p-button-secondary" 
          onClick={() => setManageDialogVisible(true)} 
          tooltip="Manage Countries" 
        />
      </div>

      <Dialog 
        header="Manage Countries" 
        visible={manageDialogVisible} 
        style={{ width: '75vw' }} 
        onHide={() => setManageDialogVisible(false)}
      >
        <CountryList onDataChange={fetchCountries} />
      </Dialog>
    </div>
  );
};

export default CountryHandlers;